var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"calendar-container"},[_c('div',{staticClass:"calendar-container__calendar-view"},[_c('Calendar',{attrs:{"type":"onlycomponent","predictions":_vm.predictions,"await-for-seasons":false,"is-full":""},on:{"tournament-selected":_vm.onTournamentSelected}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }